import React from 'react'

function Header() {
    return (
        <section className="header container pt-4 my-5">
            <div className="header-row">
                <div>
                    <h1 className="mb-lg-3">Your Journey For Education <br/> Begins With Us</h1>
                    <p className="text-secondary py-4 my-large">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sapiente fugit minima consequatur quod perspiciatis ullam.
                    </p>
                    <button className="my-btn">OUR COURSES</button>
                </div>
                <div className="header-img">
                    <h1>Learn to Grow</h1>
                </div>
            </div>
        </section>
    )
}

export default Header
